export enum ReportTabsEnum {
  CHART = 'chart',
  DATA = 'data',
  PROPERTIES = 'properties',
}
